module.exports = __webpack_public_path__ + "static/media/ace.f5e03550.svg";